import { Decimal } from 'decimal.js';
import { dividendReportName, type DividendReportRow, type DividendReportTotals } from '@hjci-investorhub-v2/domain';
export interface VisibleDividendRow { row: DividendReportRow; depth: number; }
export interface DividendSort { key: keyof DividendReportTotals | 'name'; descending: boolean; }

export function visibleDividendRows(roots: DividendReportRow[], expanded: Set<string>, sort: DividendSort[]): VisibleDividendRow[] {
  const result: VisibleDividendRow[] = [];
  const visit = (rows: DividendReportRow[], depth: number) => [...rows].sort((a, b) => {
    for (const s of sort) {
      const av = s.key === 'name' ? dividendReportName(a) : a.totals[s.key], bv = s.key === 'name' ? dividendReportName(b) : b.totals[s.key];
      if (av === null || bv === null) { if (av !== bv) return av === null ? 1 : -1; continue; }
      const difference = s.key === 'name' ? av.localeCompare(bv, 'en', { numeric: true }) : new Decimal(av).comparedTo(bv);
      if (difference) return s.descending ? -difference : difference;
    }
    return 0;
  }).forEach(row => { result.push({ row, depth }); if (expanded.has(row.id)) visit(row.children, depth + 1); });
  visit(roots, 0); return result;
}
